import { z } from "zod";

import { AtomIdSchema, CellIdSchema, IsoTimestampSchema } from "./common.js";

export const CellEffectSchema = z.enum([
  "targets",
  "supports",
  "threatens",
  "proves",
  "uses",
  "merges",
]);
export type CellEffect = z.infer<typeof CellEffectSchema>;

export const CellStatusSchema = z.enum(["active", "inactive"]);
export type CellStatus = z.infer<typeof CellStatusSchema>;

export const CellRecordSchema = z.object({
  createdAt: IsoTimestampSchema,
  effect: CellEffectSchema,
  from: AtomIdSchema,
  id: CellIdSchema,
  status: CellStatusSchema,
  to: AtomIdSchema,
  updatedAt: IsoTimestampSchema,
});
export type CellRecord = z.infer<typeof CellRecordSchema>;
